<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <i class="fa fa-list"></i> Tipos de Comprobantes
        <router-link
          class="pull-right btn btn-sm btn-success text-white"
          to="/tipos-comprobantes/crear-tipo-comprobante"
        >
          <i class="fa fa-plus" /> Nuevo
        </router-link>
      </div>
      <b-row>
        <b-col cols="12">
          <b-table
            hover
            small
            show-empty
            empty-text="No hay registros para mostrar"
            responsive="sm"
            :items="items"
            :fields="fields"
            :per-page="perPage"
            :busy="isLoading"
          >
            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>&nbsp; &nbsp;Cargando...</strong>
              </div>
            </template>
            <template slot="top-row">
              <td style="width:100px;">
                <input
                  type="text"
                  v-model="prefijo"
                  class="form-control"
                  v-on:keyup.enter="getRegistros()"
                  style="max-width:80%; margin:0;"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="descripcion"
                  class="form-control"
                  v-on:keyup.enter="getRegistros()"
                />
              </td>
              <td></td>
            </template>
            <template slot="actions" slot-scope="row">
              <router-link class="enlace" v-b-tooltip.hover title="Editar" :to="'/tipos-comprobantes/'+ row.item.id"><i class="fa fa-pencil" /></router-link>
              <a
                class="enlace text-primary"
                @click="eliminar(row.item)"
                v-b-tooltip.hover
                title="Eliminar"
              >
                <i class="fa fa-trash"></i>
              </a>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "TipoComprobantes",
  data: () => {
    return {
      prefijo: undefined,
      descripcion: undefined,
      perPage: 15,
      currentPage: 1,
      totalRows: 0,
      isLoading: true,
      items: [],
      fields: [
        {
          label: "Prefijo",
          key: "prefijo",
          sortable: true
        },
        {
          label: "Descripcion",
          key: "descripcion",
          sortable: true
        },{
          label: "",
          key: "actions",
          sortable: false
        }
      ]
    };
  },
  created() {
    this.getRegistros();
  },
  methods: {
    async getRegistros() {
      this.isLoading = true;
      try {
        let res = await axios.post("/api/catalogos/tipocomprobantes/registros",{
            perPage: this.perPage,
            page: this.currentPage,
            prefijo: this.prefijo,
            descripcion: this.descripcion
          }
        );
        this.items = [];
        this.items = res.data.data;
        this.totalRows = res.data.total;
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    eliminar(registro) {
      this.$swal({
        title: "Desea eliminar?",
        text:"Esta segur@ que desea borrar el registro?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Borrar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          axios.delete("/api/catalogos/tipocomprobantes/" + registro.id).then(res => {
            let resp = res.data;
            if (resp.status == "ok") {
              this.$swal({
                toast: true,
                position: "top-end",
                html:
                  '<span class="text-success"> Eliminado Correctamente</span>',
                type: "success",
                showConfirmButton: false,
                timer: 2000
              });
              this.getRegistros();
            } else{
              return toastr["error"](resp.errors);
            } 
          });
        }
      });
    },
  }
};
</script>
<style scoped>
.enlace {
  cursor: pointer;
  margin-left: 0.75em;
  margin-right: 0.75em;
}
</style>